import React, { useEffect } from "react";

// Bump this string whenever the changelog content changes — old "seen" flags expire.
export const WHATS_NEW_VERSION = "2026-02-feat-batch-16";

const SHIPPED = [
  { emoji: "💎", text: "PRO PLAYER is now $1.99/mo (was $0.99). PRO Players show a blue ✓ verified check next to their name everywhere." },
  { emoji: "🏟", text: "ANY league member can pay $9.99/mo to upgrade their league to PRO — and the paying member also gets PRO Player status as a bonus." },
  { emoji: "🤝", text: "League owners can TRANSFER OWNERSHIP to another member or ASSIGN a single MANAGER for delegated day-to-day control." },
  { emoji: "🛡", text: "Admin panel now has a LEAGUES tab: search, transfer ownership, or DISSOLVE leagues that need to go." },
  { emoji: "🚩", text: "Report Player + admin Reports inbox with suspend / restore flow." },
  { emoji: "🤝", text: "Dashboard FRIENDS tile with friend list + remove + block / unblock." },
  { emoji: "📸", text: "Holo card PRINT no longer clips text. SHARE button uses the native share sheet on mobile." },
];

const NEXT_UP = [
  "Match-result reversal / dispute flow.",
  "Multi-week leaderboard archive (last 12 weeks of champions).",
  "Tournament bracket integration with score_events as single source of truth.",
];

export function WhatsNewModal({ open, onClose }) {
  useEffect(() => {
    if (open && typeof window !== "undefined") {
      try { localStorage.setItem("lh_whatsnew_seen", WHATS_NEW_VERSION); } catch { /* ignore */ }
    }
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[110] bg-black/80 backdrop-blur-md p-4 flex items-center justify-center"
      onClick={onClose}
      data-testid="whats-new-backdrop"
    >
      <div
        className="glass neon-glow rounded-3xl p-7 w-full max-w-2xl max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
        data-testid="whats-new-modal"
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="text-[10px] tracking-[4px] text-[#14b8a6] font-bold">✨ WHAT'S NEW</p>
            <h2 className="font-display text-3xl md:text-4xl grad-text mt-1">FRESH PATCH</h2>
            <p className="text-xs text-[#a3a3ac] mt-1">{WHATS_NEW_VERSION}</p>
          </div>
          <button
            onClick={onClose}
            data-testid="whats-new-close"
            className="text-white/60 hover:text-white text-2xl"
          >
            <i className="fas fa-times" />
          </button>
        </div>

        <p className="text-[10px] tracking-widest text-[#14b8a6] mt-5">SHIPPED</p>
        <ul className="mt-2 space-y-2" data-testid="whats-new-shipped">
          {SHIPPED.map((s, i) => (
            <li key={i} className="glass rounded-2xl p-3 flex items-start gap-3">
              <span className="text-xl shrink-0">{s.emoji}</span>
              <span className="text-sm text-white/85">{s.text}</span>
            </li>
          ))}
        </ul>

        <p className="text-[10px] tracking-widest text-[#14b8a6] mt-5">UP NEXT</p>
        <ul className="mt-2 space-y-1.5 list-disc list-inside" data-testid="whats-new-next">
          {NEXT_UP.map((n, i) => (
            <li key={i} className="text-sm text-white/70">{n}</li>
          ))}
        </ul>

        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            data-testid="whats-new-got-it"
            className="btn-neon rounded-2xl px-6 py-3 text-sm tracking-widest"
          >
            GOT IT 🚀
          </button>
        </div>
      </div>
    </div>
  );
}

export default WhatsNewModal;
